import React from "react";

const MainNavLinks = (props: any) => {
  return <div className='MainNavLinks'>{props.children}</div>;
};

export default MainNavLinks;
